import { render } from "./NoImg.vue?vue&type=template&id=17b727a2"
const script = {}

const cssModules = {}
import style0 from "./NoImg.vue?vue&type=style&index=0&id=17b727a2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__